module.exports = [
  require("./default.json"),

  require("./logitechf310-directinput-chrome-linux.json"),
  require("./logitechf310-directinput-chrome-osx.json"),
  require("./logitechf310-directinput-chrome-windows.json"),
  require("./logitechf310-directinput-ff-linux.json"),
  require("./logitechf310-directinput-ff-osx.json"),
  require("./logitechf310-directinput-ff-windows.json"),

  require("./logitechf310-xinput-chrome-linux.json"),
  require("./logitechf310-xinput-ff-linux.json"),

  require("./ps4-chrome-linux.json"),
  require("./ps4-chrome-osx.json"),
  require("./ps4-chrome-windows.json"),
  require("./ps4-ff-linux.json"),
  require("./ps4-ff-osx.json"),

  require("./xbone-chrome-linux.json"),
  require("./xbone-chrome-osx-linux.json"),
  require("./xbone-ff-linux.json"),

  require("./xbox360-chrome-osx.json"),
  require("./xbox360-chrome-windows.json"),
  require("./xbox360-ff-windows.json"),
  require("./xbox360-ff-linux.json")
];



//////////////////
// WEBPACK FOOTER
// ./~/html5-gamepad/mappings/index.js
// module id = 199
// module chunks = 0